import { NavMenu } from '@shopify/app-bridge-react';
import { Link } from "react-router-dom";
import Language from "../../i18n/Language";
const t = Language;

const NavMenuList = () => {

    return (
        <NavMenu>
            <Link rel="home" to="/dashboard">Home</Link>
            <Link to="/website-check">{t("SEO Checker")}</Link>
            <Link to="/speedOpt">{t("Speed Optimization") + ' ⚡'}</Link>
            <Link to="/on-page-seo">{t("On-page SEO Scan")}</Link>
            <Link to="/searchAppearance">{t("Search Appearance")}</Link>
            <Link to="/backlinks">{t("Link Management")}</Link>
            <Link to="/keywordRearch">{t("Keyword Research")}</Link>
            {/* <Link to="/reports">{t("Report")}</Link> */}
            <Link to="/plan">{t("Pricing")}</Link>
            <Link to="/settings">{t("Settings")}</Link>
        </NavMenu>
    );
}

export default NavMenuList;